import React from 'react';
import 'App.css';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Helmet from 'react-helmet';

import { Base as BaseLexus } from 'ui/lexus/containers';
import { Base as BaseToyota } from 'ui/toyota/containers';

import {
    ModalError as ModalErrorLexus,
    ModalCheckStatus as ModalCheckStatusLexus,
    ModalInvalidAStatusLink as ModalInvalidAStatusLinkLexus,
    Loader as LoaderLexus,
} from 'ui/lexus/components';

import {
    ModalError as ModalErrorToyota,
    ModalCheckStatus as ModalCheckStatusToyota,
    ModalInvalidAStatusLink as ModalInvalidAStatusLinkToyota,
    Loader as LoaderToyota,
} from 'ui/toyota/components';

import { isFramed } from 'utils';
import {
    fetchSite,
    fetchFrame,
    fetchStatus,
    fetchDC,
    checkError,
} from 'redux/brand/actionCreators';

import { TechPageBase } from 'ui/techPage/containers';
import { Root } from './styles';
import LexusIcon from './lexus/outlines/favicon.ico';
import ToyotaIcon from './toyota/outlines/favicon.ico';

const getDomain = (string = '') => (string.match(/(?::\/\/)([^/]*)/) || [])[1] || '';

const LoaderContainer = styled.div`
    box-sizing: border-box;
    min-height: 100vh;
    width: 100%;
    position: relative;
    background: #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .loader-block{
        position: absolute;
        top: calc(50% - 100px);
        left: calc(50% - 100px);
    }
`;

const BRANDS = {
    Toyota: {
        logo: ToyotaIcon,
        name: 'Toyota',
    },
    Lexus: {
        logo: LexusIcon,
        name: 'Lexus',
    },
};

const isDev = process.env.NODE_ENV === 'development';

const REDIRECT_TIMEOUT = 15000; // 15s

const FAKE_ERROR_URL = 'return_somewhere_error';

const DEFAULT_BRAND = 'Lexus';

class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCheckStatus: false,
            errorFrame: false,
            gotStatusPage: false,
            showModalError: false,
            version: '',
            description: '',
            showTechPage: false,
            showLoader: false,
            brand: '',
            stopRedirect: false,
        };
    }

    componentDidMount() {
        const url = document.location.href;
        const parsedUrl = new URL(url);

        if (parsedUrl.search.search('stop') !== -1) {
            this.setState({
                stopRedirect: true,
            });
        }

        if (parsedUrl.pathname.search('techPage') !== -1) {
            this.setState({
                showTechPage: true,
            });
            return null;
        }

        if (isFramed() === true) {
            if (window.parent !== null) {
                window.parent.postMessage(window.location.href, '*');
            } else {
                window.top.postMessage(window.location.href, '*');
            }
        } else {
            // тут идет проверка ответа на действие в iframe
            window.addEventListener('message', (e) => {
                if (typeof e.data === 'string' && e.data.search('callback') !== -1) {
                    const {
                        data: {
                            dealerCenterRedirectTimer,
                        },
                    } = this.props.frame;
                    this.setState({
                        showLoader: true,
                    });
                    if (
                        dealerCenterRedirectTimer < 1000
                    ) {
                        // Если dealerCenterFailUrl  == null тогда мы берем и проверяем e.data в которой содержится callback
                        // Если он введет на  домен в котором мы уже находимся, то мы должны подставить параметр stop в url для того чтоб не было зацикливания
                        const billingPageUrl = isDev ? process.env.REACT_APP_DOMAIN : document.location.host;
                        const dealerCenterlUrl = this.props.frame.data.dealerCenterFailUrl ? getDomain(this.props.frame.data.dealerCenterFailUrl) : getDomain(e.data);
                        const splitUrl = e.data.split('?');
                        const isBillingPageUrl = billingPageUrl === dealerCenterlUrl;
                        const parsedCallback = new URL(e.data);
                        const callbackDomain = splitUrl[0];
                        const callbackParams = splitUrl[1];
                        // только для теста и предпрода, на проде надо эту логику убирать  ?id=${orderId}&stop
                        // тут идет проверка перехода после того как frame отработа
                        if (parsedCallback.search.search('code') !== -1) {
                            const internalDomainFail = this.props.frame.data.dealerCenterFailUrl || callbackDomain;
                            const externalDomainFail = this.props.frame.data.dealerCenterFailUrl || e.data;

                            window.location.href = isBillingPageUrl
                                ? internalDomainFail + `?stop&${callbackParams}`
                                : externalDomainFail;
                        } else {
                            const internalDomainSuccess = this.props.frame.data.dealerCenterSuccessUrl || callbackDomain;
                            const externalDomainSuccess = this.props.frame.data.dealerCenterSuccessUrl || e.data;

                            window.location.href = isBillingPageUrl
                                ? internalDomainSuccess + `?stop&${callbackParams}`
                                : externalDomainSuccess;
                        }
                    } else {
                        window.location.href = e.data;
                    }
                }
            }, false);
            const token = parsedUrl.pathname.replace(`${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '');
            // тут может надо будет убрать fail
            if ((token.search('callback') !== -1) || (token.search('fail') !== -1)) {
                const errorCode = parsedUrl.search.split('&').pop().split('=')[1];
                this.props.fetchStatus(parsedUrl);
                if (parsedUrl.search.search('code') !== -1) {
                    this.props.checkError(errorCode);
                }
            } else if (token.search('check') !== -1) {
                this.setState({
                    gotStatusPage: true,
                    showCheckStatus: true,
                });
                this.props.fetchStatus(parsedUrl);
            } else {
                this.props.fetchFrame(token);
            }
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.state.showTechPage === true) {
            return null;
        }
        if (prevProps.dealerCenter.isLoaded === this.props.dealerCenter.isLoaded) {
            if (prevProps.frame.isLoaded !== this.props.frame.isLoaded) {
                const {
                    frame: {
                        data: {
                            dealerCenter,
                            order,
                            orderId,
                            status,
                        },
                    },
                } = this.props;


                //редирект на статусную страницу если оплата прошла не через frame
                const url = document.location.href;
                const parsedUrl = new URL(url);
                if ((parsedUrl.search.search('stop') === -1) && (status === 'Подтвержден')) {
                    const splitUrl = parsedUrl.href.split(/pay/);
                    window.location.href = `${splitUrl[0]}pay/callback?stop&id=${orderId}`;
                }

                this.props.fetchDC(dealerCenter);
                this.setState({ brand: order.brand || DEFAULT_BRAND });
            } else if (prevProps.status.isLoaded !== this.props.status.isLoaded) {
                const {
                    status: {
                        data: {
                            dealerCenter,
                            order,
                        },
                    },
                } = this.props;
                this.setState({ brand: order?.brand || DEFAULT_BRAND });
                this.props.fetchDC(dealerCenter);
                this.props.fetchSite(dealerCenter);
            }
        } else if (this.props.status.isLoaded && this.props.dealerCenter.isLoaded && this.state.gotStatusPage === false) {
            const {
                errorFrame,
                showModalError,
                stopRedirect,
            } = this.state;
            const SHOW_ERROR_MODAL = showModalError && errorFrame;
            const {
                status: {
                    data: {
                        dealerCenterSuccessUrl,
                        dealerCenterRedirectTimer,
                    },
                },
            } = this.props;
            // Здесь была проблема на проде TB-7354
            if (SHOW_ERROR_MODAL === false && !stopRedirect && dealerCenterSuccessUrl) {
                this.startRedirectTimer(
                    dealerCenterSuccessUrl,
                    dealerCenterRedirectTimer || REDIRECT_TIMEOUT,
                );
            }
        }
        if (this.props.errorCheckStatus.data.errorDescription && this.state.errorFrame === false) {
            this.setState({
                errorFrame: true,
                showModalError: true,
            });
        }
        return null;
    }

    startRedirectTimer(returnUrl) { // returnTimeout removed from parameters temporarily
        setTimeout(() => {
            window.location.href = returnUrl;
        }, 0); // returnTimeout * 0 replaced with 0
    }

    handleCheckStatusClose = () => {
        this.setState({
            showCheckStatus: false,
        });
    };

    // eslint-disable-next-line consistent-return
    handleErrorClose = () => {
        const {
            dealerCenter: {
                error: dealerCenterError,
            },
            status: {
                error: statusError,
            },
            frame: {
                error: frameError,
            },
        } = this.props;
        if (dealerCenterError || statusError || frameError) {
            return null;
        }
        this.setState({
            showModalError: false,
        });
        const {
            status: {
                data: {
                    dealerCenterFailUrl,
                    dealerCenterRedirectTimer,
                },
            },
        } = this.props;
        this.startRedirectTimer(
            dealerCenterFailUrl || FAKE_ERROR_URL,
            dealerCenterRedirectTimer || REDIRECT_TIMEOUT,
        );
    };

    render() {
        const {
            frame: {
                isLoading: isLoadingFrame,
                isLoaded: isLoadedFrame,
                error: frameError,
            },
            status: {
                isLoaded: isLoadedStatus,
                data: {
                    paymentTimeIsOver,
                },
                error: statusError,
            },
            errorCheckStatus: {
                data: {
                    errorDescription,
                },
            },
            dealerCenter: {
                error: dealerCenterError,
            },
        } = this.props;

        const {
            showCheckStatus,
            gotStatusPage,
            errorFrame,
            showModalError,
            showTechPage,
            showLoader,
            brand,
        } = this.state;

        let orderNumber = '';

        if (this.props.frame && this.props.frame.order) {
            orderNumber = this.props.frame.order.merchantNumber;
        } else if (this.props.status && this.props.status.order) {
            orderNumber = this.props.frame.status.merchantNumber;
        }

        const SHOW_ERROR_MODAL = (showModalError && errorFrame) || dealerCenterError || statusError || frameError;
        const SHOW_CHECK_STATUS = showCheckStatus && !paymentTimeIsOver && gotStatusPage;
        const SHOW_CHECK_STATUS_INVALID = showCheckStatus && paymentTimeIsOver && gotStatusPage;

        const SHOW_LOADER = ((isLoadingFrame && !isLoadedFrame) || showLoader);

        return (
            <Root brand={brand}>
                {!brand && SHOW_ERROR_MODAL && (
                    <ModalErrorToyota
                        error={errorDescription}
                        text={errorDescription || statusError || frameError || 'На данный момент данные дилерского центра недоступны.'}
                        onClose={this.handleErrorClose}
                        orderNumber={orderNumber}
                    />
                )}
                {!brand && !showTechPage && !SHOW_ERROR_MODAL && (
                    <LoaderContainer>
                        <LoaderLexus />
                    </LoaderContainer>
                )}
                { brand && (
                    <>
                        <Helmet>
                            <link rel="shortcut icon" href={`${BRANDS[brand].logo}?v=2`} type="image/x-icon" />
                        </Helmet>
                    </>
                )}
                {showTechPage && <TechPageBase /> }
                {brand === 'Toyota' && (
                    <>
                        {SHOW_LOADER && <LoaderToyota /> }
                        {SHOW_CHECK_STATUS
                            ? <ModalCheckStatusToyota showCheckStatus={showCheckStatus} handleClose={this.handleCheckStatusClose} />
                            : isLoadedStatus
                                ? <BaseToyota isStatus isLoadedFrame={isLoadedFrame} gotStatusPage={4} error={errorFrame} isLoadedStatus={isLoadedStatus} />
                                : isLoadedFrame
                                    ? <BaseToyota isLoadedFrame={isLoadedFrame} />
                                    : null}
                        {SHOW_CHECK_STATUS_INVALID && <ModalInvalidAStatusLinkToyota paymentTimeIsOver={paymentTimeIsOver} />}
                        {SHOW_ERROR_MODAL && (
                            <ModalErrorToyota
                                error={errorDescription}
                                text={errorDescription || statusError || frameError || 'На данный момент данные дилерского центра недоступны.'}
                                onClose={this.handleErrorClose}
                                orderNumber={orderNumber}
                            />
                        )}
                    </>
                )}
                {brand === 'Lexus' && (
                    <>
                        {SHOW_LOADER && <LoaderLexus /> }
                        {SHOW_CHECK_STATUS
                            ? <ModalCheckStatusLexus showCheckStatus={showCheckStatus} handleClose={this.handleCheckStatusClose} />
                            : isLoadedStatus
                                ? <BaseLexus isStatus isLoadedFrame={isLoadedFrame} gotStatusPage={4} error={errorFrame} isLoadedStatus={isLoadedStatus} />
                                : isLoadedFrame
                                    ? <BaseLexus isLoadedFrame={isLoadedFrame} />
                                    : null}
                        {SHOW_CHECK_STATUS_INVALID && <ModalInvalidAStatusLinkLexus paymentTimeIsOver={paymentTimeIsOver} />}
                        {SHOW_ERROR_MODAL && (
                            <ModalErrorLexus
                                error={errorDescription}
                                text={errorDescription || statusError || frameError || 'На данный момент данные дилерского центра недоступны.'}
                                onClose={this.handleErrorClose}
                                orderNumber={orderNumber}
                            />
                        )}
                    </>
                )}
            </Root>
        );
    }
}

export default connect(
    state => ({
        frame: state.brand.frame,
        status: state.brand.status,
        dealerCenter: state.brand.dealerCenter,
        errorCheckStatus: state.brand.errorCheckStatus,
    }),

    {
        fetchSite,
        fetchFrame,
        fetchStatus,
        fetchDC,
        checkError,
    },
)(MainPage);
